import { Component } from '@angular/core';

@Component({
  selector: 'section-content',
  templateUrl: './section-content.component.html',
  styleUrls: ['./section-content.component.scss'],
  standalone: false,
})
export class SectionContentComponent {}
